'use strict';

let _export = {};

//http://paletton.com/#uid=63V0-0kbdpL4wXy5PGEe7h-iB94

_export.colors = {
  "primary" : "#4386AB",
  "primary_contrast" : "#FFFFFF",
  "primary_shade" : "#0A2239",
  "primary_tint" : "#009DDC",
  "primary_hover" : "#F0F8FC",
  "primary_gardient": "linear-gradient(157deg, rgba(10,34,57,1) 0%, rgba(10,34,57,1) 0%, rgba(0,157,220,1) 100%)",

  "color_warn" : "#f2c955",
  "color_warn_light": "#fae8a2",
  "color_error" : "#FF0000",
  "color_error_light" : "#ffcfcf",

  "color1_l2" : "#D8DCF6",
  "color1_l1" : "#ACB0CC",
  "color1_main" : "#62678D",
  "color1_d1" : "#3B4060",
  "color1_d2" : "#191C32",

  "color2_l2" : "#D3EFF4",
  "color2_l1" : "#9EBBC1",
  "color2_main" : "#53787E",
  "color2_d1" : "#315056",
  "color2_d2" : "#13282C",

  "color3_l2" : "#E4D6F6",
  "color3_l1" : "#B8A9CB",
  "color3_main" : "#725E8B",
  "color3_d1" : "#4A395F",
  "color3_d2" : "#221731",

  "color4_l2" : "#FFF5DB",
  "color4_l1" : "#FFF2D1",
  "color4_main" : "#CDB985",
  "color4_d1" : "#8C7B4E",
  "color4_d2" : "#483D1E",

  "white" : "#FFFFFF",
  "black" : "#000000",
  "grey": "#cccccc",
  "grey_dark": "#a1a1a1"
}
// Let's make all colors available in the root (i.e. $primary1)
for( let key in _export.colors) {
  _export[key] = _export.colors[key];
}

_export.layout = {
  "mobile-max" : "(max-width : 980px)",
  "mobile-min" : "(min-width : 981px)"
}
// Let's make all layout settings available in the root (i.e. $mobile-max)
for( let key in _export.layout) {
  _export[key] = _export.layout[key];
}

_export.fontsizes = {
  "fontsize-small" : "10px",
  "fontsize-normal" : "12px",
  "fontsize-big" : "14px",
  "fontsize-centerheading" : "32px",
}
// Let's make all fontsizes available in the root (i.e. $primary1)
for( let key in _export.fontsizes) {
  _export[key] = _export.fontsizes[key];
}


module.exports = _export;



// WEBPACK FOOTER //
// ./src/style/index.js